import React, { FunctionComponent } from 'react';
import ErrorView from 'components/ErrorView';

const Success: FunctionComponent = () => {
  return (
    <ErrorView
      title="Your parking registration has been submitted successfully."
      message="Please follow any entry instructions that have been shared with you."
    />
  );
};

export default Success;
